export default __webpack_public_path__ + "static/media/mobile_tc2_Hk.6546f170.webp";